import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from "react-redux";

class ProtectedRoute extends React.Component {

    render() {
        const Component = this.props.component;

        return this.props.isAuth ? (
            <Component {...this.props}/>
        ) : (
                <Redirect to={{ pathname: '/' }} />
            );
    }
}

const mapStateToProps = (state, ownProps) => ({
    connection_id: state.tenant.connection_id,
    isAuth: state.user.isAuth,
});

export default connect(
    mapStateToProps,
    null
)(ProtectedRoute);
